import { Component, OnInit, Injector } from "@angular/core";
import { AppComponentBase } from '@shared/app-component-base';
import { CustomCommon } from '@shared/custom-common/custom-common';
import Swal from "sweetalert2";

@Component({
  selector: 'app-custom-confirm',
  template: `<label>CustomConfirmComponent</label>`
})



export class CustomConfirmComponent extends AppComponentBase implements OnInit {

  constructor(
    injector: Injector,
  ) {
    super(injector);
  }

  ngOnInit() {
  }

  public customConfirm(callback?: (isConfirmed: boolean, isCancelled?: boolean) => void, text?: string, title?: string, confirmText?: string, cancelText?: string) {
    var titles = undefined;
    var texts = undefined;
    var confirmTexts = undefined;
    var cancelTexts = undefined;
      
    titles = this.l(CustomCommon.AreYouSure);
    
    if(text === undefined || text === null) {
      texts = this.l(CustomCommon.DataSaved);
    } else {
      texts = text
    }
    if(confirmText === undefined || confirmText === null) {
      confirmTexts = this.l(CustomCommon.confirmText);
    } else {
      confirmTexts = confirmText
    }
    if(cancelText === undefined || cancelText === null) {
      cancelTexts = this.l(CustomCommon.cancelText);
    } else {
      cancelTexts = cancelText
    }
    return Swal.fire({
      title: titles,
      text: texts,
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: cancelTexts,
      confirmButtonText: confirmTexts,

    }).then((result) => {
      if (result.isConfirmed) {
        callback && callback(result.value);
      } 
    })
  };
}
